import { MotorsportsCurrentCalendarProps, MotorsportsCurrentCalendar } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { CurrentCalendarQuery } from "./types";

import transformQuery from "./transformers/query-transformer";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<CurrentCalendarQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const disableClientRender = true;

export const getServerProps = ({
  props,
}: WidgetContext<CurrentCalendarQuery>): MotorsportsCurrentCalendarProps => {
  return transformQuery(props);
}

const CurrentCalendarContainer = ({
  props,
  ...rest
}: WidgetContext<MotorsportsCurrentCalendarProps>) => {
  log({ props, ...rest });

  return <MotorsportsCurrentCalendar {...props} />;
}

export default CurrentCalendarContainer;